import { ApiAuthTokens } from "@/utils/token";
import { AddCartResource, GetCartResource, GetCartResourceCartItems } from "../generated-api";
import ApiClient from "../nesterenko";
import { formattedCart } from "./adapter";

export class ApiCart {
  static async getCart(auth?: ApiAuthTokens): Promise<GetCartResourceCartItems | null> {
    const data = await ApiClient.get<GetCartResource>(`/cart`, {}, { auth });

    return formattedCart(data);
  }

  static async postCart(body: AddCartResource): Promise<GetCartResourceCartItems | null> {
    const data = await ApiClient.post<GetCartResource>(`/cart`, body);

    return formattedCart(data);
  }
}
